export const OFFERS_LIST_LIMIT = 12
export const OFFERS_LIST_LIMIT_STEP = 8
export const YOUTUBE_OPTIONS = {
  noCookie: true,
  controls: 1,
  rel: 0,
  showinfo: 0,
  iv_load_policy: 3,
  modestbranding: 0,
  color: 'white',
}

export const LEXICON_PER_PAGE = 5
export const FAQ_QUESTION_PER_PAGE = 7
